import Booking from '/modules/hotels/src/js/components/order/cancellation-policy/model/booking';
import Text from '/modules/hotels/src/js/components/order/cancellation-policy/model/text';

class CancellationPolicy {
    #options = {};
    #data = {};

    constructor(options = {}) {
        this.#options = options;
    }

    clear() {
        this.#data = {};
    }

    toMs(time) {
        return time < 1e12 ? time * 1000 : time;
    }

    validate(data) {
        const isValid = {
            no_refund: false,
            penalty: false,
            free: false,
            no: false,
        };

        if (typeof data === 'object' && data !== null && !Array.isArray(data)) {
            const { free, no, no_refund, penalty } = data;

            isValid.free = (
                typeof free?.date === 'string' &&
                typeof free?.time === 'number'
            );

            isValid.no = (
                typeof no?.date === 'string' &&
                typeof no?.time === 'number'
            );
            
            isValid.penalty = (
                typeof penalty?.date  === 'string' &&
                typeof penalty?.time  === 'number' &&
                typeof penalty?.price === 'number'
            );

            isValid.no_refund = (
                typeof no_refund?.value === 'number'
            );
        }

        return isValid;
    }

    set(data) {
        this.clear();

        let booking = data;
        let isValid = this.validate(booking);
        if (Object.values(isValid).every((valid) => !valid)) {
            booking = Booking(booking);
            isValid = this.validate(booking);
        }

        const { free, penalty, no, no_refund } = booking;

        const policyText = Text(this.#options.textType);

        // бесплатная отмена
        if (isValid.free) {
            free.time = this.toMs(free.time);

            if (free.time > Date.now()) {
                free.text = policyText.getFreeCancellation(free);
    
                this.#data = { free };
            }
        }

        // отмена с предоплатой
        if (isValid.no) {
            no.time = this.toMs(no.time);
            no.text = policyText.getNoCancellation(no);
            
            this.#data = { ...this.#data, no }; 
        }

        // отмена со штрафом
        if (isValid.penalty) {
            penalty.time = this.toMs(penalty.time);
            penalty.text = policyText.getPenaltyCancellation(penalty);

            this.#data = { ...this.#data, penalty };
        }

        // задаток не возвращается
        if (isValid.no_refund) {
            no_refund.text = policyText.getNoRefundCancellation(no_refund);

            this.#data = { ...this.#data, no_refund };
        }
    }

    get() {
        return {...this.#data};
    }
}

export default CancellationPolicy;